<div class="overflow-y-auto height-without-bar lg:h-full">
  <section class="relative px-2 pb-24 pt-4 sm:px-3 lg:pt-28">
    <div class="pointer-events-none absolute inset-x-0 top-0 h-72 bg-gradient-to-b from-slate-100/90 via-white/60 to-transparent"></div>

    <div class="relative mx-auto w-full max-w-6xl">
      <div class="grid gap-3 lg:grid-cols-[1.08fr_0.92fr] lg:gap-5">
        <article class="rounded-[26px] border border-slate-200/80 bg-white/95 p-4 shadow-[0_20px_60px_-40px_rgba(15,23,42,0.45)] backdrop-blur sm:p-5">
          <div class="flex items-center justify-between gap-4">
            <a
              routerLink="/"
              class="inline-flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50"
              [attr.aria-label]="'ugc_program.back_home' | translate">
              <svg class="h-4 w-4" fill="none" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.49887 1.57579C6.85935 1.21531 6.85935 0.630847 6.49887 0.270363C6.13838 -0.090121 5.55392 -0.090121 5.19344 0.270363L0.270363 5.19344C0.090121 5.37368 0 5.60992 0 5.84615C0 5.97131 0.0249097 6.09066 0.0700419 6.19949C0.115088 6.30837 0.181862 6.41037 0.270363 6.49887L5.19344 11.4219C5.55392 11.7824 6.13838 11.7824 6.49887 11.4219C6.85935 11.0615 6.85935 10.477 6.49887 10.1165L3.15158 6.76923H15.0769C15.5867 6.76923 16 6.35595 16 5.84615C16 5.33635 15.5867 4.92308 15.0769 4.92308H3.15158L6.49887 1.57579Z"
                  fill="currentColor" />
              </svg>
            </a>

            @if (!isLoadingEligibility() && !eligibilityError()) {
              <span class="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-600">
                {{ getStatusLabelKey() | translate }}
              </span>
            }
          </div>

          <div class="mt-5">
            <p class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
              {{ 'ugc_program.eyebrow' | translate }}
            </p>
            <h1 class="mt-2.5 max-w-xl text-[30px] font-semibold leading-[1.05] text-slate-900 lg:text-[44px]">
              {{ 'ugc_program.title' | translate }}
            </h1>
            <p class="mt-4 max-w-2xl text-sm leading-6 text-slate-600 lg:text-base">
              {{ 'ugc_program.subtitle' | translate }}
            </p>
          </div>

          <div class="mt-6 grid gap-2.5 sm:grid-cols-4">
            <article class="rounded-2xl border border-slate-200/80 bg-slate-50/80 p-3.5 sm:p-4">
              <p class="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500">
                {{ 'ugc_program.stats.reputation' | translate }}
              </p>
              @if (isLoadingEligibility()) {
                <div class="mt-3 h-8 w-20 animate-pulse rounded bg-slate-200"></div>
              } @else {
                <p class="mt-3 text-2xl font-semibold text-slate-900">
                  {{ eligibility()?.currentReputation ?? '-' }}
                </p>
              }
            </article>

            <article class="rounded-2xl border border-slate-200/80 bg-slate-50/80 p-3.5 sm:p-4">
              <p class="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500">
                {{ 'ugc_program.stats.minimum_reputation' | translate }}
              </p>
              @if (isLoadingEligibility()) {
                <div class="mt-3 h-8 w-20 animate-pulse rounded bg-slate-200"></div>
              } @else {
                <p class="mt-3 text-2xl font-semibold text-slate-900">
                  {{ eligibility()?.minimumRequiredReputation ?? '-' }}
                </p>
              }
            </article>

            <article class="rounded-2xl border border-slate-200/80 bg-slate-50/80 p-3.5 sm:p-4">
              <p class="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500">
                {{ 'ugc_program.stats.pending' | translate }}
              </p>
              @if (isLoadingEligibility()) {
                <div class="mt-3 h-8 w-20 animate-pulse rounded bg-slate-200"></div>
              } @else {
                <p class="mt-3 text-2xl font-semibold text-slate-900">
                  {{ eligibility()?.pendingSubmissions ?? '-' }}
                </p>
              }
            </article>

            <article class="rounded-2xl border border-slate-200/80 bg-slate-50/80 p-3.5 sm:p-4">
              <p class="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500">
                {{ 'ugc_program.stats.pending_limit' | translate }}
              </p>
              @if (isLoadingEligibility()) {
                <div class="mt-3 h-8 w-20 animate-pulse rounded bg-slate-200"></div>
              } @else {
                <p class="mt-3 text-2xl font-semibold text-slate-900">
                  {{ eligibility()?.maxPendingSubmissions ?? '-' }}
                </p>
              }
            </article>
          </div>
        </article>

        <article class="rounded-[26px] border border-slate-200/80 bg-white/95 p-4 shadow-[0_20px_60px_-40px_rgba(15,23,42,0.45)] sm:p-5">
          <p class="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
            {{ 'ugc_program.meaning.title' | translate }}
          </p>

          <div class="mt-4 space-y-2.5">
            <article class="rounded-2xl border border-slate-200/80 bg-slate-50/70 p-3.5 sm:p-4">
              <h2 class="text-base font-semibold text-slate-900">
                {{ 'ugc_program.meaning.items.contribute.title' | translate }}
              </h2>
              <p class="mt-1 text-sm leading-6 text-slate-600">
                {{ 'ugc_program.meaning.items.contribute.description' | translate }}
              </p>
            </article>

            <article class="rounded-2xl border border-slate-200/80 bg-slate-50/70 p-3.5 sm:p-4">
              <h2 class="text-base font-semibold text-slate-900">
                {{ 'ugc_program.meaning.items.review.title' | translate }}
              </h2>
              <p class="mt-1 text-sm leading-6 text-slate-600">
                {{ 'ugc_program.meaning.items.review.description' | translate }}
              </p>
            </article>

            <article class="rounded-2xl border border-slate-200/80 bg-slate-50/70 p-3.5 sm:p-4">
              <h2 class="text-base font-semibold text-slate-900">
                {{ 'ugc_program.meaning.items.rewards.title' | translate }}
              </h2>
              <p class="mt-1 text-sm leading-6 text-slate-600">
                {{ 'ugc_program.meaning.items.rewards.description' | translate }}
              </p>
            </article>
          </div>
        </article>

        <article class="rounded-[26px] border border-slate-200/80 bg-white/95 p-4 shadow-[0_20px_60px_-40px_rgba(15,23,42,0.45)] sm:p-5 lg:col-span-2">
          @if (isLoadingEligibility()) {
            <div class="space-y-3">
              <div class="h-6 w-32 animate-pulse rounded bg-slate-200"></div>
              <div class="h-4 w-full animate-pulse rounded bg-slate-200"></div>
              <div class="h-4 w-5/6 animate-pulse rounded bg-slate-200"></div>
              <div class="h-12 w-full animate-pulse rounded-2xl bg-slate-200"></div>
            </div>
          } @else if (eligibilityError()) {
            <div class="rounded-2xl border border-rose-100 bg-rose-50 p-4">
              <p class="text-sm font-semibold text-rose-700">{{ 'ugc_program.error_title' | translate }}</p>
              <p class="mt-2 text-sm leading-6 text-rose-600">
                {{ 'ugc_program.error_body' | translate }}
              </p>
            </div>
          } @else if (canAccept()) {
            <div class="grid gap-4 lg:grid-cols-[1fr_auto] lg:items-end">
              <div>
                <p class="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
                  {{ 'ugc_program.ready.eyebrow' | translate }}
                </p>
                <h2 class="mt-3 text-2xl font-semibold text-slate-900">
                  {{ (programStatus() === 'INVITED' ? 'ugc_program.ready.invited_title' : 'ugc_program.ready.eligible_title') | translate }}
                </h2>
                <p class="mt-3 text-sm leading-6 text-slate-600">
                  {{ (programStatus() === 'INVITED' ? 'ugc_program.ready.invited_body' : 'ugc_program.ready.eligible_body') | translate }}
                </p>
              </div>

              <div class="flex flex-col gap-3">
                <button
                  type="button"
                  class="inline-flex items-center justify-center rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:opacity-60"
                  [disabled]="isSubmitting()"
                  (click)="acceptProgram()">
                  {{ (isSubmitting() ? 'ugc_program.ready.accepting' : 'ugc_program.ready.accept') | translate }}
                </button>
                <a
                  routerLink="/"
                  class="inline-flex items-center justify-center rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-700">
                  {{ 'ugc_program.ready.later' | translate }}
                </a>
              </div>
            </div>

            @if (acceptError()) {
              <div class="mt-4 rounded-2xl border border-rose-100 bg-rose-50 p-3.5 sm:p-4">
                <p class="text-sm font-semibold text-rose-700">{{ 'ugc_program.accept_error_title' | translate }}</p>
                <p class="mt-1 text-sm leading-6 text-rose-600">
                  {{ 'ugc_program.accept_error_body' | translate }}
                </p>
              </div>
            }
          } @else if (isAcceptedAndAllowed()) {
            <div class="grid gap-4 lg:grid-cols-[1fr_auto] lg:items-end">
              <div>
                <p class="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
                  {{ 'ugc_program.accepted.eyebrow' | translate }}
                </p>
                <h2 class="mt-3 text-2xl font-semibold text-slate-900">
                  {{ 'ugc_program.accepted.title' | translate }}
                </h2>
                <p class="mt-3 text-sm leading-6 text-slate-600">
                  {{ 'ugc_program.accepted.body' | translate }}
                </p>
              </div>

              <a
                routerLink="/ugc/new"
                class="inline-flex items-center justify-center rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white">
                {{ 'ugc_program.accepted.cta' | translate }}
              </a>
            </div>
          } @else {
            <div class="grid gap-4 lg:grid-cols-[1fr_auto] lg:items-end">
              <div>
                <p class="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
                  {{ getInactiveEyebrowKey() | translate }}
                </p>
                <h2 class="mt-3 text-2xl font-semibold text-slate-900">
                  {{ getInactiveTitleKey() | translate }}
                </h2>
                <p class="mt-3 text-sm leading-6 text-slate-600">
                  {{ getInactiveBodyKey() | translate }}
                </p>
              </div>

              <a
                routerLink="/"
                class="inline-flex items-center justify-center rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-700">
                {{ 'ugc_program.waiting.secondary_cta' | translate }}
              </a>
            </div>

            @if (blockingReasonKeys().length) {
              <div class="mt-4 rounded-2xl border border-amber-200/80 bg-amber-50/70 p-3.5 sm:p-4">
                <p class="text-[11px] font-semibold uppercase tracking-[0.16em] text-amber-700">
                  {{ 'ugc_program.blocked.reasons_title' | translate }}
                </p>

                <div class="mt-3 grid gap-2">
                  @for (reasonKey of blockingReasonKeys(); track reasonKey) {
                    <div class="flex gap-2 text-sm leading-6 text-amber-900">
                      <span class="mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-amber-500" aria-hidden="true"></span>
                      <span>
                        {{ reasonKey | translate: {
                          current: eligibility()?.currentReputation,
                          minimum: eligibility()?.minimumRequiredReputation,
                          pending: eligibility()?.pendingSubmissions,
                          max: eligibility()?.maxPendingSubmissions
                        } }}
                      </span>
                    </div>
                  }
                </div>
              </div>
            }
          }
        </article>
      </div>
    </div>
  </section>
</div>
